import { useCallback } from 'react';

import { useAppDispatch } from '@/store';
import { openCreditGate as openCreditGateAction } from '@/store/features/ui.feature';

/**
 * Call-site API for the global insufficient-credits dialog.
 *
 * Replace `toast.error('Insufficient credits…')` with
 * `openCreditGate({ needed, action })` — the dialog (CreditGateDialog,
 * mounted once in AppShell) reads the live balance itself and offers the
 * paths to more credits instead of a dead end.
 */
export function useCreditGate() {
  const dispatch = useAppDispatch();

  const openCreditGate = useCallback(
    (payload?: { needed?: number; action?: string }) => {
      dispatch(openCreditGateAction(payload));
    },
    [dispatch]
  );

  return { openCreditGate };
}
